import { IPortfolioOptimizationTemplate } from '@/interfaces/portfolioOptimization.interface'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Button, Divider, Menu, MenuItem, Typography } from '@mui/material'
import React from 'react'

type StartNewOptimizationButtonProps = {
  label: string
  options?: IPortfolioOptimizationTemplate[]
  onStartNewClick?: () => void
  onPrevOptionClick?: (
    savedOptimization: IPortfolioOptimizationTemplate,
  ) => void
  loading?: boolean
  selectedOption?: IPortfolioOptimizationTemplate | null
}

const StartNewOptimizationButton = ({
  label,
  options,
  onStartNewClick,
  onPrevOptionClick,
  loading,
  selectedOption,
}: StartNewOptimizationButtonProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const onStartNew = () => {
    setAnchorEl(null)
    ;(onStartNewClick as Function)()
  }

  return (
    <div>
      <Button
        size='medium'
        id='basic-button'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
      >
        {selectedOption?.longName || label}
      </Button>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem key={0} onClick={onStartNew}>
          {label}
        </MenuItem>
        <Divider sx={{ margin: 0, padding: 0 }} />
        <Typography variant='overline' fontWeight='600' sx={{ marginLeft: 4 }}>
          Saved Optimization Templates
        </Typography>
        {loading && <MenuItem disabled>Loading...</MenuItem>}
        {options?.map(
          ({ longName, shortName }: IPortfolioOptimizationTemplate) => (
            <MenuItem
              key={shortName}
              onClick={() => {
                handleClose()
                ;(onPrevOptionClick as Function)({ longName, shortName })
              }}
            >
              {longName}
            </MenuItem>
          ),
        )}
        {options?.length === 0 && (
          <MenuItem disabled>No saved templates</MenuItem>
        )}
      </Menu>
    </div>
  )
}

export default StartNewOptimizationButton
